export default function removeTokensFromLocalStorage() {
  localStorage.removeItem('refreshToken');
  localStorage.removeItem('accessToken');
}
